import api from './api';

// Drops null/undefined/empty filter params so the query string stays clean —
// same helper shape as leaveDashboardService/expenseDashboardService.
const clean = (params) => {
  const out = {};
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== '') out[key] = value;
  });
  return out;
};

// Contract FROZEN ahead of backend (2026-09-16, no backend yet — see
// AtsDashboardPage report for the assumptions this rests on):
//   GET /v1/ats-dashboard?from={ISO}&to={ISO}  (both optional, server defaults
//   to the last 90 days). Single payload feeds every card on the page:
//   { kpi, funnel, stageDurations, slaBreach, sources, aging, interviewHealth }
//   under res.data.data. Rate fields (offerAcceptanceRate / rate /
//   conversionRate / noShowRate / cancelRate) are `null` — not 0 — when their
//   denominator is zero.
export const getAtsDashboard = (params) => api.get('/v1/ats-dashboard', { params: clean(params) });
